import React from "react";
import {
  Input,
} from "reactstrap";

const ConcesionariosNotificationTable = ({
  modal,
  setModal,
  validation,
  concesionarios,
  reportNotificationList,
}) => {
  const routeConfigId = validation.values.report_notifications;

  const reportName = reportNotificationList.find(
    (i) => i.id == routeConfigId
  )?.name;

  console.log("routeConfigId", routeConfigId);
  console.log("reportName", reportName);
  if(!validation.values.report_notifications) return <></>;

  return (
    <div className="card" size="lg">
      <div className="card-header">
        {`Configurar notificaciones para concesionarios`}
      </div>
      <div className="card-body">
        <table className="table table-sm table-hover">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Concesionario</th>
              <th scope="col">Unidades</th>
              <th scope="col" className="text-center">
                Whats App
              </th>
              <th scope="col" className="text-center">
                Correo electrónico
              </th>
            </tr>
          </thead>
          <tbody>
            {concesionarios.map((concesionario, index) => {
              const routeConfigId = validation.values.report_notifications;
              const concesionariosChecked = validation.values[routeConfigId] ?? {};

              const isPhoneValidated = concesionario?.phone_validated;
              const isEmailVerified = concesionario?.email_verified_at;

              return (
                <tr key={concesionario.id}>
                  <th scope="row">{index + 1}</th>
                  <td>
                    {concesionario?.name} {concesionario?.lname1}{" "}
                    {concesionario?.lname1}
                  </td>
                  <td>
                    {concesionario?.units.length == 0 && "Sin unidades asignadas"}
                    {concesionario?.units.map((unit, index) => {return unit.number}).join(', ')}
                  </td>
                  <td className="text-center">
                    {isPhoneValidated ? (
                      <Input
                        type="checkbox"
                        onChange={(e) => {
                          const newConcecionariosChecked = {
                            ...concesionariosChecked,
                            [concesionario.id]: {
                              ...concesionariosChecked[concesionario.id],
                              whatsapp: e.target.checked,
                            },
                          };

                          validation.setFieldValue(
                            routeConfigId,
                            newConcecionariosChecked
                          );
                        }}
                        checked={
                          concesionariosChecked[concesionario.id]?.whatsapp
                            ? true
                            : false
                        }
                      />
                    ) : (
                      <i className="far fa-bell-slash text-secondary text-opacity-50"></i>
                    )}
                  </td>
                  <td className="text-center">
                    {isEmailVerified ? (
                      <Input
                        type="checkbox"
                        onChange={(e) => {
                          const newConcecionariosChecked = {
                            ...concesionariosChecked,
                            [concesionario.id]: {
                              ...concesionariosChecked[concesionario.id],
                              email: e.target.checked,
                            },
                          };

                          validation.setFieldValue(
                            routeConfigId,
                            newConcecionariosChecked
                          );
                        }}
                        checked={
                          concesionariosChecked[concesionario.id]?.email
                            ? true
                            : false
                        }
                      />
                    ) : (
                      <i className="far fa-bell-slash text-secondary text-opacity-50"></i>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ConcesionariosNotificationTable;
